import { Schema } from "effect"
import { ContentMeta, EntityRef, RecordMeta } from "../common"
import { AreaId, ArtifactId, HookId, IntakeId, Markdown, ProjectId } from "../ids"

// #region intake
/**
 * Captured input waiting for triage (decision 0002): an idea, feature request, bug or question from the web app,
 * the CLI, the external MCP server or a webhook. Intake never creates work by itself: the lead (woken, coalesced)
 * or a person triages it, then links it to the node it became, marks it a duplicate or closes it. Attached logs and
 * screenshots are untrusted data (`tainted`). Lives in the Project DO; Phase 2.
 */
export const IntakeKind = Schema.Literals(["idea", "feature", "bug", "question"])

export const IntakeSource = Schema.TaggedUnion({
  web: {},
  cli: {},
  mcp: { client: Schema.String }, // "claude-code", "codex", "claude.ai", "chatgpt"
  email: { from: Schema.String }, // later
  webhook: { hookId: HookId }, // later (App Store reviews, a CMS)
  agent: {}, // an agent's turn (a routine); createdBy names the agent and its run
})

export const IntakeStatus = Schema.TaggedUnion({
  new: {},
  triaged: {}, // looked at, area confirmed, not yet turned into work
  linked: { ref: EntityRef }, // became (or joined) this goal, initiative, task or proposal
  duplicate: { of: IntakeId },
  closed: { reason: Schema.String },
})

export const Intake = Schema.Struct({
  ...RecordMeta, // createdBy = who captured it (a person, or an agent via a routine)
  ...ContentMeta,
  id: IntakeId,
  projectId: ProjectId,
  kind: IntakeKind,
  title: Schema.String,
  body: Markdown,
  attachments: Schema.Array(ArtifactId),
  source: IntakeSource,
  suggestedAreaId: Schema.NullOr(AreaId),
  status: IntakeStatus,
  tainted: Schema.Boolean, // external sources and attachments are untrusted; triage renders them as quoted data
})
export type Intake = typeof Intake.Type
// #endregion intake
